import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { InvoiceService } from "src/app/_services/invoice.service";
import { PodService } from "src/app/_services/pod.service";
import { PosService } from "src/app/_services/posService";

@Component({
  selector: "app-po-details",
  templateUrl: "./po-details.component.html",
  styleUrls: ["./po-details.component.scss"],
})
export class PoDetailsComponent implements OnInit {
  po: any;
  responseData: any;
  isError: any;
  isEmpty = false;
  displayName: any;
  sessionExpired = false;
  errorMsg = "";
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  poPaymentTermExist = false;
  validityExist = false;
  deliveryDateExist = false;
  lineItems: any;
  invoices: any = [];
  showBarcodePrefix = false;

  getPo(data: any) {
    return this.http.post("https://jsw.qa.payex.live/api/dashboard/fetchPo", data);
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private authService: AuthService,
    private posService: PosService,
    private podService: PodService,
    private invoiceService: InvoiceService
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  /** Match material POD line display; raw poLineNo unchanged on the model. */
  formatLineItemNo(value: string | number | null | undefined): string {
    if (value === null || value === undefined) {
      return "";
    }
    const s = String(value).trim();
    if (/^\d+$/.test(s)) {
      return String(parseInt(s, 10));
    }
    return s;
  }

  private lineItemNoComparable(value: string | number | null | undefined): string | number {
    const s = String(value ?? "").trim();
    if (/^\d+$/.test(s)) {
      return parseInt(s, 10);
    }
    return s;
  }

  ngOnInit(): void {
    console.log("po details");
    this.setShowBarcodePrefix();

    this.displayName = localStorage.getItem("displayName");
    // const userData = {
    //     poNo: this.route.snapshot.params["poNo"],
    //     action: "get",
    //     sellerCode: localStorage.getItem("vendorCode"),
    //     session: { sessionId: localStorage.getItem("eippSession") },
    // };

    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: 50,
      pageNo: 1,
      filters: [
        {
          key: "docType",
          value: "PO",
        },
        {
          key: "docNoNumberOrString",
          value: this.route.snapshot.params["poNo"],
        },
        {
          key: "supplierCode",
          value: localStorage.getItem("vendorCode"),
        },
      ],
      sellercode: this.authService.getSellerCode(),
      isExport: false,
      linkFilters: [],
      isAP: true,
      isPOD: true,
    };

    console.log(this.podService.getStoredPo());
    const storedPo = this.podService.getStoredPo();
    console.log("Stored PO:", storedPo);

    this.posService.fetchPurchaseOrders(userData).subscribe(
      (res) => {
        this.responseData = res;

        if (this.responseData.code == 200) {
          this.po = this.responseData.data.list[0];
          console.log(this.responseData.data.list[0]);

          this.po = { ...storedPo, ...this.po };
          console.log(this.po, "po details");

          this.posService.setPos(this.po);

          const lineitemsReq = {
            filters: [{ key: "ldgrId", value: this.po?._id }],
            pageNo: 1,
            isExport: true,
            sortConfig: {},
            isAP: true,
          };

          const config: any = this.invoiceService.getAllConfig();
          console.log(config, "config");

          if (this.po.cmpCode) {
            console.log(this.po.cmpCode, "this.po.cmpCode");

            const companyCode = config.companyCodes.find((item: any) => parseInt(item.companyCode) === parseInt(this.po.cmpCode));
            console.log(companyCode, "companyCode");
            if (companyCode) {
              this.po.companyName = `${companyCode.companyName} - ${companyCode.companyCode}`;
            }
          }

          if (this.po.purchaseOrg) {
            const purchaseOrg = config.purchaseOrganizations.find((item: any) => item.purchaseOrganization === this.po.purchaseOrg);
            console.log(purchaseOrg, "purchaseOrg");
            if (purchaseOrg) {
              this.po.purchaseOrgName = `${purchaseOrg.purchaseOrganization} - ${purchaseOrg.description}`;
            }
          }

          if (this.po.erpDocType) {
            const docType = config.purchaseDoc.find((item: any) => item.docType === this.po.erpDocType);
            console.log(docType, "docType");
            if (docType) {
              this.po.docTypeName = `${docType.docType} - ${docType.description}`;
            }
          }

          this.posService.fetchLineItems(lineitemsReq).subscribe(
            (res) => {
              this.responseData = res;

              if (this.responseData.code == 200) {
                this.lineItems = this.responseData.data.list;

                // After line items are loaded, fetch POD data to calculate open quantities
                this.fetchPurchaseOrders();
                this.fetchInvoices();
              }
              setTimeout(() => {
                if (typeof this.po.payTermRec !== "undefined") {
                  this.poPaymentTermExist = true;
                }

                if (typeof this.po.validityEndDate !== "undefined") {
                  this.validityExist = true;
                }

                if (typeof this.lineItems[0]?.dlryDate !== "undefined") {
                  this.deliveryDateExist = true;
                }
              }, 0);
            },
            (error) => {}
          );
        }

        // let sortedLineItems = this.lineItems.sort(
        //     (a, b) => (a.po_item_line > b.po_item_line ? 1 : -1)
        // );

        // this.lineItems = sortedLineItems;
      },
      (error) => {}
    );
  }

  fetchPurchaseOrders() {
    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: 50,
      pageNo: 1,
      filters: [
        {
          key: "docType",
          value: "POD",
        },
        {
          key: "poNoNumberOrString",
          value: this.po._id,
        },
      ],
      sellercode: localStorage.getItem("vendorCode"),
      isExport: false,
      linkFilters: [],
      isAP: true,
      isPOD: true,
    };

    this.posService.fetchPurchaseOrders(userData).subscribe(
      (res: any) => {
        if (res && res.data && res.data.list) {
          const podList = res.data.list;

          // Calculate open quantity for each line item
          this.lineItems.forEach((lineItem) => {
            console.log(lineItem, "lineItem");
            // Find all POD items that match this line item's poLineNo
            const matchingPodItems = podList.filter(
              (podItem: any) => this.lineItemNoComparable(podItem.poLineNo) === this.lineItemNoComparable(lineItem.poLineNo)
            );

            // Sum up quantities from all matching POD items
            const deliveredQuantity = matchingPodItems.reduce((sum: number, podItem: any) => {
              return sum + (parseInt(podItem.quantityJsw) || 0);
            }, 0);

            console.log(deliveredQuantity, "deliveredQuantity");

            // Calculate open quantity
            const originalQuantity = lineItem.quantity || 0;
            lineItem.openQuantity = originalQuantity - deliveredQuantity > 0 ? originalQuantity - deliveredQuantity : 0;
          });
        }
      },
      (error) => {
        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  fetchInvoices() {
    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: 50,
      pageNo: 1,
      filters: [
        {
          key: "docType",
          value: "APINV",
        },
        {
          key: "poNoNumberOrString",
          value: this.po._id,
        },
      ],
      sellercode: localStorage.getItem("vendorCode"),
      isExport: false,
      linkFilters: [],
      isAP: true,
      isPOD: true,
    };

    this.posService.fetchPurchaseOrders(userData).subscribe(
      (res: any) => {
        console.log(res, "res");

        if (res && res.data && res.data.list) {
          const podList = res.data.list;

          // Calculate open quantity for each line item
          this.invoices = podList;

          // Calculate Open PO Amount for each invoice
        }
      },
      (error) => {
        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  accountLogout() {
    const userData = {
      session: { sessionId: localStorage.getItem("eippSession") },
    };
    this.authService.logOut(userData).subscribe(
      (res) => {
        const responseData: any = res;
        if (responseData.status === "ok") {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  setShowBarcodePrefix() {
    const currentUser: any = this.authService.getCurrentUser();
    this.showBarcodePrefix = currentUser?.uiConfig?.showPoBarcodePrefix === true;
  }
}
